import React, { memo } from 'react';
import type { BaseHit } from 'instantsearch.js';
import algoliasearchHelper from 'algoliasearch-helper';
import { Category, M20CategoriesModule } from '~/lib/data-contract';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import CategoryCarousel from './CardCarousel/CardCarousel';
import { SkipToNextBlock } from '~/shared/components/SkipToNextBlock.ts';

export type CardProps = {
    item: Category;
    className?: string;
    priority?: boolean;
    largePadding?: boolean;
    noPadding?: boolean;
    dataid?: string;
    desktopAspectRatio?: string;
    tabletAspectRatio?: string;
    hitsResults?: algoliasearchHelper.SearchResults<BaseHit>;
};

export const M20Categories = memo(
    ({ isLastItem, items, headline, priority, ...rest }: M20CategoriesModule) => {
        return (
            <>
                {!!items?.length && (
                    <ModuleContainer {...rest}>
                        {!isLastItem && <SkipToNextBlock />}

                        <CategoryCarousel headline={headline} priority={priority} items={items} />
                    </ModuleContainer>
                )}
            </>
        );
    },
);
